import { FlexCenter } from "@9amhealth/shared";
import type { UserAddressApiDto } from "@9amhealth/openapi";
import type { FC } from "react";
import React from "react";
import translate from "src/lib/translate";
import { getHeadingProps, useFocusHeading } from "src/lib/useFocusHeading";
import ShippingForm from "src/ui/components/ShippingForm/ShippingForm";
import type {
  SignupCustomStep,
  SignupCustomStepShippingAddress
} from "src/ui/components/SignupCustomContent/SignupCustom.types";
import { SignupCustomStepType } from "src/ui/components/SignupCustomContent/SignupCustom.types";
import { InputFocusVirtualKeyboardPadding } from "../../StyledComponents/InputFocusVirtualKeyboardPadding";

const SignupCustomStepShippingAddressContent: FC<{
  step: SignupCustomStepShippingAddress;
  onStepCompleted: (step: SignupCustomStep) => Promise<boolean> | boolean;
}> = ({ step, onStepCompleted }) => {
  const { headingRef } = useFocusHeading();

  const handleSuccess = async (data?: UserAddressApiDto) => {
    if (data?.street) {
      await onStepCompleted(step);
    }
  };

  return (
    <>
      <FlexCenter>
        <nine-spacer s="md"></nine-spacer>
        <nine-heading>
          <h1 className="as-h3" ref={headingRef} {...getHeadingProps()}>
            {step.shippingFormPageProps?.title ??
              translate("your_shipping_info")}
          </h1>
          <nine-spacer s="xs"></nine-spacer>
          <p className="m0 color-c-80">
            {step.shippingFormPageProps?.subtitle ??
              translate("your_shipping_info_subtitle")}
          </p>
        </nine-heading>

        <nine-spacer s="xl"></nine-spacer>

        <InputFocusVirtualKeyboardPadding>
          <ShippingForm onSuccess={handleSuccess} />
        </InputFocusVirtualKeyboardPadding>
        <nine-spacer s="xl"></nine-spacer>
        <nine-spacer s="xl"></nine-spacer>
      </FlexCenter>
    </>
  );
};

const SignupCustomStepShippingAddressRender: FC<{
  step: SignupCustomStep;
  onStepCompleted: (step: SignupCustomStep) => Promise<boolean> | boolean;
}> = React.memo(({ step, onStepCompleted }) => {
  const isShippingStep = step.type === SignupCustomStepType.ShippingAddress;
  return isShippingStep ? (
    <SignupCustomStepShippingAddressContent
      step={step}
      onStepCompleted={onStepCompleted}
    />
  ) : (
    <></>
  );
});

export default SignupCustomStepShippingAddressRender;
